import React, {useEffect, useMemo, useRef, useState} from 'react';
import './ImageSlider.scss';

import SwiperCore, {Navigation, Pagination, A11y, Lazy} from 'swiper/core';
import {Swiper, SwiperSlide} from 'swiper/react';
// import 'swiper/swiper.scss';
import {breakpointDt, breakpointDt_mid} from '../../constants/constants';
import PreloadImage from 'react-preload-image';
import LazyImage from "../../hooks/LazyImage";

SwiperCore.use([Navigation, Pagination, A11y, Lazy]);

const ImageSlider = ({
                         data,
                         sliderHeight,
                         isImageThumbnail,
                         alwaysSlide,
                         isHoverCursorEnabled
                     }) => {

    // 사진 썸네일을 쓰고자 하는 경우,
    // swiper-pagination-bullet을 다 잡는다.
    // data로 들어온 이미지를 인덱스 별로 연결한다.
    // 스타일은 그거에 맞춰서 준다.

    const isMobile = useMemo(() => window.innerWidth < breakpointDt_mid, []);
    const [slideThreshold, setSlideThreshold] = useState(window.innerWidth > breakpointDt ? 100 : 0);
    const [useHighRes, setUseHighRes] = useState(false);
    const highResRequested = useRef(false);

    const getLowResUrl = (url) => {
        if (!url) return url;
        const lastDot = url.lastIndexOf('.');
        return `${url.slice(0, lastDot)}-416x416${url.slice(lastDot)}`;
    };

    useEffect(() => {
        if (highResRequested.current || !data || data.size === 0) return;

        const firstEntry = Array.from(data)[0];

        // webp가 있으면 브라우저가 직접 처리하므로 low-res 스왑 불필요
        if (firstEntry[1].has('webp')) return;

        let targetFormat;
        firstEntry[1].forEach((value, key) => {
            if (key !== 'webp' && key !== 'type') targetFormat = key;
        });
        if (!targetFormat) return;

        const originalSrc = firstEntry[1].get(targetFormat);
        if (!originalSrc) return;

        highResRequested.current = true;

        const highResImg = new Image();
        highResImg.onload = () => setUseHighRes(true);
        highResImg.src = originalSrc;
    }, [data]);

    useEffect(() => {

        if (isImageThumbnail) {
            const bullets = document.querySelectorAll('.pagination-main-detail-images .swiper-pagination-bullet');

            bullets.forEach((bullet, i) => {
                bullet.classList.add('imageThumbnail');
                let targetFormat;

                Array.from(data)[i][1].forEach((value, key) => {
                    if (key !== 'webp' && key !== "type") {
                        targetFormat = key;
                    }
                })
                bullet.innerHTML = Array.from(data)[i][1].has('webp') ? `
                            <picture class="pagination-dt">
                               <source srcSet=${Array.from(data)[i][1].get('webp')} type="image/webp"/>
                                <img src=${Array.from(data)[i][1].get(targetFormat)}
                                     loading='lazy'
                                      style="width: 64px; height: 64px; object-fit:cover; display:flex;"/>
                            </picture>
            ` : ` <picture class="pagination-dt">
                    <img src=${Array.from(data)[i][1].get(targetFormat)}
                      loading='lazy'
                    style="width: 64px; height: 64px; object-fit:cover; display:flex;"/>
                </picture>`;
            });
        }

    }, [data]);

    return (

        <div className="imgSlider" style={{width: '100%', height: '100%'}}>
            <Swiper
                lazy={isMobile ? {loadPrevNext: true, loadPrevNextAmount: 1, loadOnTransitionStart: true} : false}
                preloadImages={!isMobile}
                spaceBetween={0}
                slidesPerView={1}
                pagination={{
                    el: '.pagination-main-detail-images',
                    type: 'bullets',
                    clickable: true
                }}
                loop={true}
                threshold={alwaysSlide ? 0 : slideThreshold}
                style={{width: '100%', height: '100%'}}
                navigation={isHoverCursorEnabled ?
                    {
                        nextEl: '.hoverCursorNext',
                        prevEl: '.hoverCursorPrev',

                    } :
                    false
                }


            >


                {Array.from(data).map((img, i) => {
                    let targetFormat;

                    img[1].forEach((value, key) => {
                        if (key !== 'webp' && key !== "type") {
                            targetFormat = key;
                        }
                    })

                    const isFirst = i === 0;
                    const useLazy = isMobile && !isFirst;

                    return (
                        <SwiperSlide key={i}>
                            <picture>
                                {img[1].has('webp') && (
                                    isFirst
                                        ? <source type={'image/webp'} srcSet={img[1].get('webp')}/>
                                        : useLazy
                                            ? <source type={'image/webp'} data-srcset={img[1].get('webp')}/>
                                            : <source type={'image/webp'} srcSet={img[1].get('webp')}/>
                                )}
                                <img
                                    {...(isFirst
                                        ? img[1].has('webp')
                                            ? {
                                                src: img[1].get(targetFormat),
                                                fetchpriority: 'high',
                                              }
                                            : {
                                                src: useHighRes ? img[1].get(targetFormat) : getLowResUrl(img[1].get(targetFormat)),
                                                fetchpriority: 'high',
                                                onError: (e) => { e.currentTarget.onerror = null; setUseHighRes(true); }
                                              }
                                        : useLazy
                                            ? {'data-src': img[1].get(targetFormat), loading: 'lazy'}
                                            : {src: img[1].get(targetFormat), loading: 'lazy'}
                                    )}
                                    className={`imgSliderContent ${img[1].get('type') === 'cover' ? 'cover' : ''}${useLazy ? ' swiper-lazy' : ''}`}
                                    style={{
                                        height: sliderHeight,
                                        width: "100%",
                                        objectFit: img[1].get('type')
                                    }}/>
                            </picture>
                            {useLazy && <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>}
                        </SwiperSlide>
                    );
                })}

                {isHoverCursorEnabled &&
                    <>
                        <div className="hoverCursorPrev"
                             style={{
                                 cursor: 'url(/img/arrow_prev_b_72.svg)'
                             }}
                        ></div>
                        <div className="hoverCursorNext"
                             style={{
                                 cursor: 'url(/img/arrow_prev_b_72.svg)'
                             }}
                        ></div>
                    </>
                }
                <div className="pagination-main-detail-images">

                </div>
            </Swiper>

        </div>


    );
};

export default ImageSlider;
